/* ---------------------------------------------------------------------------
   STL 2026 — 4.1f  PDP gallery zoom (desktop) + 4.1g pinch (mobile)

   Desktop: frames 5580:17661 (zoomed) against the default PDP. The zoomed state
   is NOT a lightbox — it is the same page with the gallery switched from two
   columns to one, images at the full 960 gallery width, scrolled. So this file
   only toggles a class; every pixel of the layout is in custom.css.

   Zero core edits. The <script> tag is carried by a `custom_liquid` block on
   `main-product` (rule 6), and the control is built here rather than in Liquid,
   so no Madrid snippet is touched.

   Mobile: no control at all. Serena's reference is leolinofficial.com, which
   uses no zoom library — its gallery is Flickity and every element is
   `touch-action: auto`, so what you get is the browser's own page pinch. Ours
   was blocked by Swiper, and the two blockers are handled at the bottom of this
   file and in custom.css.
   ------------------------------------------------------------------------- */

(function () {
  'use strict';

  var OUTER = '.product__outer--two-column-aside';
  var ZOOMED = 'stl-gallery--zoomed';
  var BTN = 'stl-zoom-toggle';

  /* Madrid's own two-column breakpoint. Below it the columns stack and there is
     nothing to expand, so the control is not built and the state is dropped. */
  var MIN_WIDTH = 1100;

  var LABEL_IN = 'Expand images';
  var LABEL_OUT = 'Collapse images';

  var BAR = 'stl-gallery-scrollbar';

  function ensureButton(outer) {
    var main = outer.querySelector('.product__main');
    if (!main || main.querySelector('.' + BTN)) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = BTN;
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', LABEL_IN);
    main.appendChild(btn);

    /* The zoomed-state scroll indicator (frame 5580:17668). Purely decorative —
       it reports progress, it is not a control — so it is aria-hidden and the
       page's own scrollbar remains the accessible mechanism. */
    var bar = document.createElement('div');
    bar.className = BAR;
    bar.setAttribute('aria-hidden', 'true');
    bar.appendChild(document.createElement('span'));
    main.appendChild(bar);
  }

  /* Thumb length is the visible fraction of the gallery, which is what makes it a
     scrollbar rather than a progress pill — but on a 16-image product that
     fraction is ~3%, i.e. a 5px dot on a 160px track. Floored at the 40px the
     frame draws, so a real catalogue product reproduces the mock exactly and a
     two-image product still behaves correctly. */
  var TRACK = 160;
  var MIN_THUMB = 40;

  function updateBar(outer) {
    var bar = outer.querySelector('.' + BAR);
    if (!bar || !outer.classList.contains(ZOOMED)) return;

    var main = outer.querySelector('.product__main');
    if (!main) return;

    var rect = main.getBoundingClientRect();
    var total = rect.height;
    var view = window.innerHeight;

    var thumb = Math.max(MIN_THUMB, Math.min(TRACK, (view / total) * TRACK));

    /* rect.top is how far the gallery's top sits above the viewport top, so
       -rect.top is the distance scrolled into it. */
    var scrollable = total - view;
    var progress = scrollable > 0 ? -rect.top / scrollable : 0;
    progress = Math.max(0, Math.min(1, progress));

    var span = bar.firstChild;
    span.style.height = thumb + 'px';
    span.style.transform = 'translateY(' + progress * (TRACK - thumb) + 'px)';
  }

  /* Toggling the column count moves every image. Without an anchor the reader
     loses their place completely — at one-up each image is roughly twice as
     tall, so the same scrollTop lands somewhere entirely different. Hold the
     image nearest the top of the viewport still across the reflow. */
  /* HEADER_CLEAR is the sticky header's own height (30 announcement + 80 bar)
     plus a little, so the anchor is an image the reader can actually see rather
     than one hidden behind the bar. */
  var HEADER_CLEAR = 120;

  function toggleZoom(outer, btn) {
    /* MADRID RENDERS THE GALLERY FOUR TIMES — desktop, mobile, and a no-JS copy
       of each — so `outer` holds 40 `.product__media-item`s for a 10-image
       product and THIRTY OF THEM ARE HIDDEN. A hidden item's rect is all zeros,
       and `Math.abs(0)` is the smallest distance there is, so the old
       nearest-to-zero search anchored on a hidden element every single time. Its
       rect cannot move across the reflow, so the correction was always 0 and the
       reader was dropped wherever the relayout happened to leave them — which is
       what "it returns me to a random spot" was. Filter to items that have a
       layout box. */
    var items = Array.prototype.slice.call(
      outer.querySelectorAll('.product__media-item')
    ).filter(function (item) {
      return item.offsetWidth || item.offsetHeight;
    });

    /* The topmost image still clear of the sticky header — the one being looked
       at. Nearest-to-zero picks whichever image is closest to the viewport TOP
       in either direction, which on a 2-up row is often the one already scrolled
       past. */
    var anchor = null;
    for (var i = 0; i < items.length; i++) {
      if (items[i].getBoundingClientRect().bottom > HEADER_CLEAR) {
        anchor = items[i];
        break;
      }
    }
    if (!anchor) anchor = items[0] || null;

    var before = anchor ? anchor.getBoundingClientRect().top : 0;

    var on = outer.classList.toggle(ZOOMED);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? LABEL_OUT : LABEL_IN);

    if (anchor) {
      /* getBoundingClientRect forces the layout, so this reads the NEW position. */
      var delta = anchor.getBoundingClientRect().top - before;
      if (delta) window.scrollBy(0, delta);
    }

    updateBar(outer);
    updateSizes(outer, on);
  }

  /* `sizes` is markup, so it cannot describe a state that only exists at runtime.
     The Liquid declares the DEFAULT layout (33.34vw above 1100px — see the branch
     added to product-thumbnail.liquid); zoomed, each image is the full gallery
     column, so it doubles.

     Rewriting `sizes` makes the browser re-run srcset selection and upgrade to a
     larger candidate, which is the whole point: without it the zoomed image is the
     one picked for a box half its size. Un-zooming restores the smaller value —
     the browser keeps the larger file it already has rather than downgrading, so
     that costs nothing.

     Desktop wrapper only. The mobile copy is a different gallery type and is not
     zoomable. */
  var SIZES_DEFAULT = '(min-width: 1100px) calc(33.34vw * 1.18), (min-width: 750px) 50vw, 100vw';
  var SIZES_ZOOMED = '(min-width: 1100px) calc(66.67vw * 1.18), (min-width: 750px) 50vw, 100vw';

  function updateSizes(outer, zoomed) {
    outer
      .querySelectorAll('.main-product-desktop-section-wrapper .product__media img')
      .forEach(function (img) {
        img.sizes = zoomed ? SIZES_ZOOMED : SIZES_DEFAULT;
      });
  }

  /* Passive, and it early-returns unless the gallery is zoomed, so the listener
     costs nothing in the default state. No rAF: it is suspended while a tab is
     hidden, which has already caught this build out once on the PLP counter. */
  window.addEventListener(
    'scroll',
    function () {
      document.querySelectorAll(OUTER).forEach(updateBar);
    },
    { passive: true }
  );

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var btn = target.closest('.' + BTN);
    if (!btn) return;

    var outer = btn.closest(OUTER);
    if (!outer) return;

    toggleZoom(outer, btn);
  });

  /* ---- mobile pinch ------------------------------------------------------
     Swiper blocks the browser's pinch in two ways. `touch-action` is the CSS
     half and lives in custom.css; this is the JS half.

     `touchStartPreventDefault` defaults to true, and a preventDefault on
     touchstart cancels the gesture before the browser sees it. It is read at
     event time rather than captured at init, so assigning to it afterwards
     works and no core edit to global.js is needed. */
  function allowPinch() {
    var pending = false;
    document
      .querySelectorAll('.product__media-list.swiper')
      .forEach(function (el) {
        if (el.swiper && el.swiper.params) {
          el.swiper.params.touchStartPreventDefault = false;
          enableDoubleTap(el.swiper);
        } else {
          pending = true;
        }
      });
    return pending;
  }

  /* ---- mobile double-tap zoom (Serena, 13 Sep 2026) -----------------------
     Swiper 11's own Zoom module, switched on after Madrid has built the slider:
     double-tap zooms the image towards the tapped point (2.5x), the zoomed
     image can be dragged around without the slider moving, and double-tap
     again zooms out. Swiping to the next image resets the zoom.

     The module looks for a `containerClass` wrapper inside each slide; Madrid's
     `.product__media` is that wrapper (it holds the <img> and clips it), so no
     markup is added. `enable()` binds the module's events on a slider that was
     created without zoom, which is what keeps this out of global.js.

     The existing pinch (the browser's page pinch, above) is left as it was. */
  function enableDoubleTap(swiper) {
    if (!swiper || swiper.destroyed || !swiper.zoom || swiper.stlDoubleTap) return;
    if (window.innerWidth >= 750) return; /* the mobile slider exists below 750 only */
    swiper.params.zoom = Object.assign({}, swiper.params.zoom, {
      enabled: true,
      toggle: true,
      maxRatio: 2.5,
      minRatio: 1,
      containerClass: 'product__media',
      zoomedSlideClass: 'swiper-slide-zoomed'
    });
    if (typeof swiper.zoom.enable === 'function') swiper.zoom.enable();
    swiper.stlDoubleTap = true;
  }

  /* Madrid builds the slider from its own deferred script, which can finish
     after this one; retry briefly rather than depend on script order. */
  function allowPinchWhenReady(tries) {
    if (allowPinch() && tries > 0) {
      setTimeout(function () { allowPinchWhenReady(tries - 1); }, 250);
    }
  }

  function init() {
    if (window.innerWidth >= MIN_WIDTH) {
      document.querySelectorAll(OUTER).forEach(function (outer) {
        ensureButton(outer);
        updateBar(outer);
      });
    }
    allowPinchWhenReady(20);
  }

  /* Dropping the state below the breakpoint keeps the two halves from meeting:
     a page zoomed on desktop and then narrowed would otherwise carry a class
     that means nothing to the mobile slider. */
  window.addEventListener('resize', function () {
    if (window.innerWidth < MIN_WIDTH) {
      document.querySelectorAll(OUTER).forEach(function (outer) {
        outer.classList.remove(ZOOMED);
        var btn = outer.querySelector('.' + BTN);
        if (btn) {
          btn.setAttribute('aria-pressed', 'false');
          btn.setAttribute('aria-label', LABEL_IN);
        }
      });
    } else {
      document.querySelectorAll(OUTER).forEach(function (outer) {
        ensureButton(outer);
        updateBar(outer);
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Madrid re-renders the section in the theme editor, and swaps gallery markup
     on some variant changes — both drop the button and re-init the Swiper. */
  document.addEventListener('shopify:section:load', init);

  /* A size change can make Madrid rebuild the slider, which drops the zoom
     settings along with it; re-apply once it has settled. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-radios, variant-selects, .product-form__input')) {
      setTimeout(function () { allowPinchWhenReady(8); }, 600);
    }
  });
})();
